module.exports = __webpack_public_path__ + "components/flag/static/square/gb-eng-134a5dece6f45ca7b72accbb53836630.svg";